import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Heading } from './NavMenu';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ApplicationState } from '../reducers/Index';

import { UserState, ManageUsersState } from '../interface/MyInterfaces';

import { loadUsers, addNewUser, ClearMessage, disableUser, setAdministrator, sendPasswordResetEmail } from '../actions/ManageUsersActions';
import Toggle from 'react-toggle';
import { validate } from 'email-validator';


interface ManageUsersProps {
    ManageUsersState?: ManageUsersState;
    UserState?: UserState;
    loadUsers?(display_id);
    ClearMessage?();
    addNewUser?(UserState);
    disableUser?(username, value, display_id);
    setAdministrator?(username, value);
    sendPasswordResetEmail?(username, firstname, lastname, display_id);
}

interface ManageUsersLocalState {
    NewUser?: UserState;
    ShowAddUser?: boolean;
    RequiredError?: boolean;
    ValidEmailError?: boolean;
}

class ManageUsers extends React.Component<ManageUsersProps, ManageUsersLocalState> {
    constructor(props) {
        super(props);

        this.state = {
            ShowAddUser: false,
            NewUser: {
                username: "",
                firstname: "",
                lastname: "",
                qa_account: "N",
                administrator: "No",
                display_id: this.props.UserState.display_id,
                activeFlag: "Y",
                university: this.props.UserState.university
            },
            RequiredError: false,
            ValidEmailError:false
        };
        this.AddNewClicked = this.AddNewClicked.bind(this);

        this.handleAdministratorChange = this.handleAdministratorChange.bind(this);
        this.handleDisableChange = this.handleDisableChange.bind(this);

        this.handleNewUser_EmailChange = this.handleNewUser_EmailChange.bind(this);
        this.handleNewUser_FirstNameChange = this.handleNewUser_FirstNameChange.bind(this);
        this.handleNewUser_LastNameChange = this.handleNewUser_LastNameChange.bind(this);
        this.handleNewUser_AdministratorChange = this.handleNewUser_AdministratorChange.bind(this);
        this.handleNewUser_Submit = this.handleNewUser_Submit.bind(this);

        this.handleNewUser_Cancel = this.handleNewUser_Cancel.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        //this.formPreventDefault = this.formPreventDefault.bind(this);
        
    }

    componentDidMount() {
        this.props.loadUsers(this.props.UserState.display_id);
        //this.props.ClearMessage();
    }
    AddNewClicked() {
        this.setState({
            ShowAddUser: true
        });
    }
    resetPassword(event) {
        var username = event.currentTarget.dataset.id;
        var firstname = event.currentTarget.dataset.firstname;
        var lastname = event.currentTarget.dataset.lastname;

        this.props.sendPasswordResetEmail(username, firstname, lastname, this.props.UserState.display_id);
        event.preventDefault();
        
    }
    handleAdministratorChange(event) {
        var username = event.currentTarget.dataset.id;
        var adminFlag = (event.target.checked) ? "Yes" : "No";
        this.props.setAdministrator(username, adminFlag);
    }
    handleDisableChange(event) {
        var username = event.currentTarget.dataset.id;
        var activeFlag = (event.target.checked) ? "Y" : "N";
        this.props.disableUser(username, activeFlag, this.props.UserState.display_id);
    }
    handleNewUser_EmailChange(event) {
        this.setState({
            NewUser: {
                ...this.state.NewUser,
                username: event.target.value
            }
        });

    }
    handleNewUser_FirstNameChange(event) {
        this.setState({
            NewUser: { ...this.state.NewUser,firstname: event.target.value }
        });

    }
    handleNewUser_LastNameChange(event) {
        this.setState({
            NewUser: { ...this.state.NewUser,lastname: event.target.value }
        });

    }
    handleNewUser_AdministratorChange(event) {
        if (event.target.checked) {
            this.setState({
                NewUser: { ...this.state.NewUser, administrator: "Yes" }
            });
        } else {
            this.setState({
                NewUser: { ...this.state.NewUser, administrator: "No" }
            });
        }
    }
    handleNewUser_Submit(e) {
        if (this.state.NewUser.username == "" || this.state.NewUser.firstname == "" || this.state.NewUser.lastname == "")
            this.setState({ RequiredError: true });
        else {
            this.setState({ RequiredError: false });

            if (this.state.NewUser.username !== "" && !validate(this.state.NewUser.username))
                this.setState({ ValidEmailError: true });
            else {
                this.setState({ ValidEmailError: false });

                if (!this.state.RequiredError && !this.state.ValidEmailError) {
                    this.props.addNewUser(this.state.NewUser);

                    this.setState({
                        ShowAddUser: false
                    });
                }
            }
        }
    }
    handleNewUser_Cancel() {
        this.setState({
            ShowAddUser: false
        });
    }
    /*
    formPreventDefault(e) {
        e.preventDefault();
    }*/

    public render() {
        if (this.props.ManageUsersState !== undefined && this.props.ManageUsersState.UserList !== undefined) {
            var userList = this.props.ManageUsersState.UserList.map((item,index) => {
                return <tr>
                    <td>{item.username}</td>
                    <td>{item.firstname || "-"}</td>
                    <td>{item.lastname || "-"}</td>

                    {this.props.UserState.administrator == "Yes" &&
                        <td><a href="#" data-id={item.username} data-firstname={item.firstname} data-lastname={item.lastname} onClick={this.resetPassword}>Reset Password</a></td>
                    }
                    {this.props.UserState.administrator == "Yes" &&
                    <td><Toggle
                        className="mytoggle"
                        name="activeFlag"
                        data-id={item.username}
                        checked={(item.activeFlag == "Y")}
                        onChange={this.handleDisableChange} />
                    </td>
                    }
                    {this.props.UserState.administrator == "Yes" &&
                    <td>
                        <Toggle
                            className="mytoggle"
                            name="administrator"
                            data-id={item.username}
                            checked={(item.administrator == "Yes")}
                            onChange={this.handleAdministratorChange} />
                    </td>
                    }
                </tr>
            })

            return <div className='manageusers container-fluid'>
                <div className="row">
                    <div className="col-md-6">
                        <Heading value='Manage Users' />                        
                    </div>
                    {(this.props.ManageUsersState.Message !== "") && 
                        <div className="col-md-6">
                        <label className="message">{this.props.ManageUsersState.Message}
                            <i className="fa fa-window-close" onClick={this.props.ClearMessage}></i>
                            </label>
                        </div>
                    }
                </div>
                <div>
                    {this.props.UserState.administrator == "Yes" &&
                        <div className="col-md-12">
                            <button onClick={this.AddNewClicked} type="button" className="btn btn-default">Add New Portal User</button>
                        </div>
                    }
                </div>
            {this.state.ShowAddUser &&
                    <div className="row">
                    <div className="col-md-12">
                        <form>
                                <h4>Add New User - Enter Info</h4>
                                <fieldset>
                                <span>Email Address (Username)</span>
                                <input value={this.state.NewUser.username} required type="email" className="form-control" name="activeTime"
                                        onChange={this.handleNewUser_EmailChange} />

                                </fieldset>
                                <fieldset>
                                    <span>First Name</span>
                                <input value={this.state.NewUser.firstname} required type="text" className="form-control" name="activeTime"
                                        onChange={this.handleNewUser_FirstNameChange} />
                                </fieldset>
                                <fieldset>
                                    <span>Last Name</span>
                                <input value={this.state.NewUser.lastname} required type="text" className="form-control" name="activeTime"
                                        onChange={this.handleNewUser_LastNameChange} />
                                </fieldset>
                                <fieldset>
                                    <span className="mytoggle_span">Administrator</span>
                                    <Toggle
                                        className="mytoggle"
                                        name="newuser_administrator"
                                        defaultChecked={false}
                                        onChange={this.handleNewUser_AdministratorChange} />

                            </fieldset>
                            {this.state.RequiredError &&
                            <label className='incorrectpassword'>
                                All fields are required. 
                            </label>
                            }
                            {this.state.ValidEmailError &&
                                <label className='incorrectpassword'>
                                    Username must be a valid email address.
                            </label>
                            }
                                <div className="align_center">
                                    <button className="btn-primary filterButton" type="button" onClick={this.handleNewUser_Submit}>Submit</button>
                                    <button className="btn-primary filterButton" type="button" onClick={this.handleNewUser_Cancel}>Cancel</button>
                                </div>
                            </form>                        
                    </div>
                </div>
            }
                <div className="row">
                <div className="col-md-12">
                    <table className='userstable table'>
                        <thead>
                            <tr>
                                <th>Member ID</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                {this.props.UserState.administrator == "Yes" &&
                                    <th>Reset Password</th>
                                }
                                {this.props.UserState.administrator == "Yes" &&
                                    <th>Disable Member</th>
                                }
                                {this.props.UserState.administrator == "Yes" &&
                                    <th>Administrator</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {userList}
                        </tbody>
                    </table>
                </div>
                </div>
            </div>
        }
        else {
            return <div className='reports container-fluid'>
                <div className="row">
                    <div className="col-md-12">
                    <Heading value='Manage Users' />
                    <table className='reportstable table'>
                        <thead>
                            <tr>
                                <th>Member ID</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                {this.props.UserState.administrator == "Yes" &&
                                    <th>Reset Password</th>
                                }
                                {this.props.UserState.administrator == "Yes" &&
                                    <th>Disable Member</th>
                                }
                                {this.props.UserState.administrator == "Yes" &&
                                    <th>Administrator</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            <div>Loading...</div>
                        </tbody>
                        </table>
                    </div>
                </div>
            </div>
        }
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties,
    ManageUsersState: state.manageUsersProperties
});


function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loadUsers: loadUsers,
            addNewUser: addNewUser,
            ClearMessage: ClearMessage,
            disableUser: disableUser,
            setAdministrator: setAdministrator,
            sendPasswordResetEmail: sendPasswordResetEmail
        }, dispatch
    )
}


export default connect(
    mapStateToProps, // Selects which state properties are merged into the component's props
    matchDispatchToProps
)(ManageUsers);


